import { ModuleFE_Discussion } from './ModuleFE_Discussion.js';
export const ModulePackFE_DiscussionDB = [ModuleFE_Discussion];
//# sourceMappingURL=module-pack.js.map